/* =====================================================================
   NV Google Reviews (Glass) - v1.0 JS
   Edge Shapes (copied from nv-jobs-hero) + Carousel + Connected Mode
   ===================================================================== */

   // cache bust v4
(function() {
  document.querySelectorAll('#nv-google-reviews-glass[data-section-id]').forEach(function(root) {
    var sid = root.getAttribute('data-section-id');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var edgeAnimFrame = null;
    var edgeAnimOffset = 0;

    /* ---- EDGE SHAPES (exact copy from nv-jobs-hero) ---- */
    function getEdgeVar(name) {
      return parseFloat(getComputedStyle(root).getPropertyValue(name)) || 0;
    }

    function buildClipPath(animOffset) {
      var edgeTopEnabled = root.getAttribute('data-edge-top-enable') === 'true';
      var edgeBottomEnabled = root.getAttribute('data-edge-bottom-enable') === 'true';
      var edgeTop = edgeTopEnabled ? (root.getAttribute('data-edge-top') || 'none') : 'none';
      var edgeBottom = edgeBottomEnabled ? (root.getAttribute('data-edge-bottom') || 'none') : 'none';
      var edgeTopDir = root.getAttribute('data-edge-top-dir') || 'left_high';
      var edgeBottomDir = root.getAttribute('data-edge-bottom-dir') || 'left_high';

      if (edgeTop === 'none' && edgeBottom === 'none') {
        root.style.clipPath = '';
        root.style.webkitClipPath = '';
        return false;
      }

      var h = root.offsetHeight;
      var w = root.offsetWidth;
      var topH = getEdgeVar('--nv-edge-top-height');
      var bottomH = getEdgeVar('--nv-edge-bottom-height');
      var patternW = getEdgeVar('--nv-edge-pattern') || 100;

      var topPct = (topH / h) * 100;
      var bottomPct = (bottomH / h) * 100;
      var segments = Math.max(2, Math.round(w / patternW));
      var pts = [];
      var needsAnimation = false;

      /* Top edge (left to right) */
      if (edgeTop === 'none') {
        pts.push('0% 0%', '100% 0%');
      } else if (edgeTop === 'diagonal') {
        pts.push(edgeTopDir === 'left_high' ? '0% ' + topPct + '%' : '0% 0%');
        pts.push(edgeTopDir === 'left_high' ? '100% 0%' : '100% ' + topPct + '%');
      } else {
        var res = segments * 6;
        for (var i = 0; i <= res; i++) {
          var x = (i / res) * 100;
          var y = 0;
          var t = i / res;

          if (edgeTop === 'zigzag') {
            var seg = Math.floor(t * segments);
            var local = (t * segments) - seg;
            y = (local < 0.5) ? (local * 2 * topPct) : ((1 - local) * 2 * topPct);
          } else if (edgeTop === 'wave') {
            y = (Math.sin(t * segments * Math.PI * 2) * 0.5 + 0.5) * topPct;
          } else if (edgeTop === 'wave_animated') {
            y = (Math.sin((t * segments * Math.PI * 2) + animOffset) * 0.5 + 0.5) * topPct;
            needsAnimation = true;
          } else if (edgeTop === 'scallop') {
            y = (Math.cos(t * segments * Math.PI * 2) * -0.5 + 0.5) * topPct;
          } else if (edgeTop === 'scoop' || edgeTop === 'curve') {
            y = Math.sin(t * Math.PI) * topPct;
          } else if (edgeTop === 'steps') {
            var seg = Math.floor(t * segments);
            y = (seg % 2 === 0) ? topPct : topPct * 0.4;
          } else if (edgeTop === 'triangle') {
            y = (t < 0.5) ? (t * 2 * topPct) : ((1 - t) * 2 * topPct);
          } else if (edgeTop === 'rolling' || edgeTop === 'rolling_animated') {
            var rollPhase = edgeTop === 'rolling_animated' ? animOffset : 0;
            if (edgeTop === 'rolling_animated') needsAnimation = true;
            var roll1 = Math.sin(t * 3 * Math.PI + rollPhase) * 0.35;
            var roll2 = Math.sin(t * 5 * Math.PI + 1.2 + rollPhase * 0.7) * 0.25;
            var roll3 = Math.sin(t * 2 * Math.PI + 2.5 + rollPhase * 0.4) * 0.4;
            y = (0.5 + roll1 + roll2 + roll3) * topPct * 0.5;
            y = Math.max(0, Math.min(topPct, y));
          } else if (edgeTop === 'rocky' || edgeTop === 'rocky_animated') {
            var rockyPhase = edgeTop === 'rocky_animated' ? animOffset : 0;
            if (edgeTop === 'rocky_animated') needsAnimation = true;
            var r1 = Math.pow(Math.sin(t * 12 * Math.PI + rockyPhase), 2) * 0.4;
            var r2 = Math.pow(Math.sin(t * 8.4 * Math.PI + 1.5 + rockyPhase * 0.8), 2) * 0.35;
            var r3 = Math.pow(Math.sin(t * 15.6 * Math.PI + 0.8 + rockyPhase * 1.2), 2) * 0.3;
            y = Math.max(r1, r2, r3) * topPct;
          } else if (edgeTop === 'ocean' || edgeTop === 'ocean_animated') {
            var oceanPhase = edgeTop === 'ocean_animated' ? animOffset : 0;
            if (edgeTop === 'ocean_animated') needsAnimation = true;
            var wave1 = Math.sin(t * 1.5 * Math.PI + oceanPhase * 0.5) * 0.35;
            var wave2 = Math.sin(t * 2.5 * Math.PI + 1 + oceanPhase * 0.3) * 0.2;
            var wave3 = Math.sin(t * 0.8 * Math.PI + 2 + oceanPhase * 0.7) * 0.25;
            y = (0.55 + wave1 + wave2 + wave3) * topPct * 0.6;
            y = Math.max(0, Math.min(topPct, y));
          }
          pts.push(x.toFixed(2) + '% ' + y.toFixed(2) + '%');
        }
      }

      /* Bottom edge (right to left) */
      if (edgeBottom === 'none') {
        pts.push('100% 100%', '0% 100%');
      } else if (edgeBottom === 'diagonal') {
        pts.push(edgeBottomDir === 'left_high' ? '100% 100%' : '100% ' + (100 - bottomPct) + '%');
        pts.push(edgeBottomDir === 'left_high' ? '0% ' + (100 - bottomPct) + '%' : '0% 100%');
      } else {
        var res = segments * 6;
        for (var i = res; i >= 0; i--) {
          var x = (i / res) * 100;
          var y = 100;
          var t = i / res;

          if (edgeBottom === 'zigzag') {
            var seg = Math.floor(t * segments);
            var local = (t * segments) - seg;
            y = 100 - ((local < 0.5) ? (local * 2 * bottomPct) : ((1 - local) * 2 * bottomPct));
          } else if (edgeBottom === 'wave') {
            y = 100 - (Math.sin(t * segments * Math.PI * 2) * 0.5 + 0.5) * bottomPct;
          } else if (edgeBottom === 'wave_animated') {
            y = 100 - (Math.sin((t * segments * Math.PI * 2) + animOffset) * 0.5 + 0.5) * bottomPct;
            needsAnimation = true;
          } else if (edgeBottom === 'scallop') {
            y = 100 - (Math.cos(t * segments * Math.PI * 2) * -0.5 + 0.5) * bottomPct;
          } else if (edgeBottom === 'scoop' || edgeBottom === 'curve') {
            y = 100 - Math.sin(t * Math.PI) * bottomPct;
          } else if (edgeBottom === 'steps') {
            var seg = Math.floor(t * segments);
            y = 100 - ((seg % 2 === 0) ? bottomPct : bottomPct * 0.4);
          } else if (edgeBottom === 'triangle') {
            y = 100 - ((t < 0.5) ? (t * 2 * bottomPct) : ((1 - t) * 2 * bottomPct));
          } else if (edgeBottom === 'rolling' || edgeBottom === 'rolling_animated') {
            var rollPhase = edgeBottom === 'rolling_animated' ? animOffset : 0;
            if (edgeBottom === 'rolling_animated') needsAnimation = true;
            var roll1 = Math.sin(t * 3 * Math.PI + rollPhase) * 0.35;
            var roll2 = Math.sin(t * 5 * Math.PI + 1.2 + rollPhase * 0.7) * 0.25;
            var roll3 = Math.sin(t * 2 * Math.PI + 2.5 + rollPhase * 0.4) * 0.4;
            var rollY = (0.5 + roll1 + roll2 + roll3) * bottomPct * 0.5;
            y = 100 - Math.max(0, Math.min(bottomPct, rollY));
          } else if (edgeBottom === 'rocky' || edgeBottom === 'rocky_animated') {
            var rockyPhase = edgeBottom === 'rocky_animated' ? animOffset : 0;
            if (edgeBottom === 'rocky_animated') needsAnimation = true;
            var r1 = Math.pow(Math.sin(t * 12 * Math.PI + rockyPhase), 2) * 0.4;
            var r2 = Math.pow(Math.sin(t * 8.4 * Math.PI + 1.5 + rockyPhase * 0.8), 2) * 0.35;
            var r3 = Math.pow(Math.sin(t * 15.6 * Math.PI + 0.8 + rockyPhase * 1.2), 2) * 0.3;
            var rockyY = Math.max(r1, r2, r3) * bottomPct;
            y = 100 - Math.max(0, Math.min(bottomPct, rockyY));
          } else if (edgeBottom === 'ocean' || edgeBottom === 'ocean_animated') {
            var oceanPhase = edgeBottom === 'ocean_animated' ? animOffset : 0;
            if (edgeBottom === 'ocean_animated') needsAnimation = true;
            var wave1 = Math.sin(t * 1.5 * Math.PI + oceanPhase * 0.5) * 0.35;
            var wave2 = Math.sin(t * 2.5 * Math.PI + 1 + oceanPhase * 0.3) * 0.2;
            var wave3 = Math.sin(t * 0.8 * Math.PI + 2 + oceanPhase * 0.7) * 0.25;
            var oceanY = (0.55 + wave1 + wave2 + wave3) * bottomPct * 0.6;
            y = 100 - Math.max(0, Math.min(bottomPct, oceanY));
          }
          pts.push(x.toFixed(2) + '% ' + y.toFixed(2) + '%');
        }
      }

      var clipValue = 'polygon(' + pts.join(', ') + ')';
      root.style.clipPath = clipValue;
      root.style.webkitClipPath = clipValue;
      return needsAnimation;
    }

    function animateEdges() {
      var speed = getEdgeVar('--nv-edge-anim-speed') || 8;
      var increment = (Math.PI * 2) / (speed * 60);
      edgeAnimOffset += increment;
      var needsAnimation = buildClipPath(edgeAnimOffset);
      if (needsAnimation && !reduced) {
        edgeAnimFrame = requestAnimationFrame(animateEdges);
      }
    }

    function startEdgeAnimation() {
      if (edgeAnimFrame) {
        cancelAnimationFrame(edgeAnimFrame);
        edgeAnimFrame = null;
      }
      var edgeTopEnabled = root.getAttribute('data-edge-top-enable') === 'true';
      var edgeBottomEnabled = root.getAttribute('data-edge-bottom-enable') === 'true';
      var edgeTop = edgeTopEnabled ? (root.getAttribute('data-edge-top') || 'none') : 'none';
      var edgeBottom = edgeBottomEnabled ? (root.getAttribute('data-edge-bottom') || 'none') : 'none';
      var needsAnimation = (edgeTop.indexOf('_animated') !== -1 || edgeBottom.indexOf('_animated') !== -1);
      if (needsAnimation && !reduced) {
        animateEdges();
      } else {
        buildClipPath(0);
      }
    }

    startEdgeAnimation();
    window.addEventListener('resize', startEdgeAnimation);

    var edgeObserver = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        startEdgeAnimation();
      } else if (edgeAnimFrame) {
        cancelAnimationFrame(edgeAnimFrame);
        edgeAnimFrame = null;
      }
    }, { threshold: 0.1 });
    edgeObserver.observe(root);

    /* ---- CAROUSEL ---- */
    var carousel = root.querySelector('.nv-reviews__carousel');
    if (carousel) {
      var prevBtn = root.querySelector('[data-reviews-prev]');
      var nextBtn = root.querySelector('[data-reviews-next]');
      var dots = root.querySelectorAll('.nv-reviews__dot');
      var cards = carousel.querySelectorAll('.nv-reviews__card');
      var cardCount = cards.length;

      function getVisibleCount() {
        if (window.innerWidth >= 990) return 3;
        if (window.innerWidth >= 550) return 2;
        return 1;
      }

      function getScrollAmount() {
        if (!cards.length) return 0;
        var card = cards[0];
        var style = getComputedStyle(carousel);
        var gap = parseFloat(style.gap) || 16;
        return card.offsetWidth + gap;
      }

      function getCurrentIndex() {
        var scrollAmount = getScrollAmount();
        if (scrollAmount === 0) return 0;
        return Math.round(carousel.scrollLeft / scrollAmount);
      }

      function updateDots() {
        var idx = getCurrentIndex();
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === idx);
        });
      }

      function scrollPrev() {
        var scrollAmt = getScrollAmount();
        var newPos = Math.max(0, carousel.scrollLeft - scrollAmt);
        carousel.scrollTo({ left: newPos, behavior: reduced ? 'auto' : 'smooth' });
      }

      function scrollNext() {
        var scrollAmt = getScrollAmount();
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        var newPos = Math.min(maxScroll, carousel.scrollLeft + scrollAmt);
        carousel.scrollTo({ left: newPos, behavior: reduced ? 'auto' : 'smooth' });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', scrollPrev);
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', scrollNext);
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          carousel.scrollTo({ left: getScrollAmount() * i, behavior: reduced ? 'auto' : 'smooth' });
        });
      });

      var scrollTimer = null;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateDots, 100);
      }, { passive: true });

      updateDots();

      /* Drag to scroll */
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;
      var dragThreshold = 5;
      var hasDragged = false;

      carousel.style.cursor = 'grab';

      carousel.addEventListener('mousedown', function(e) {
        if (e.button !== 0) return;
        isDragging = true;
        hasDragged = false;
        startX = e.pageX;
        scrollStart = carousel.scrollLeft;
        carousel.style.cursor = 'grabbing';
        carousel.style.scrollSnapType = 'none';
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        var diff = e.pageX - startX;
        if (Math.abs(diff) > dragThreshold) {
          hasDragged = true;
        }
        carousel.scrollLeft = scrollStart - diff;
      });

      document.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false;
        carousel.style.cursor = 'grab';
        carousel.style.scrollSnapType = 'x mandatory';
        
        if (hasDragged) {
          var scrollAmt = getScrollAmount();
          var targetIndex = Math.round(carousel.scrollLeft / scrollAmt);
          carousel.scrollTo({ left: targetIndex * scrollAmt, behavior: 'smooth' });
        }
      });

      /* Touch drag support */
      var touchStartX = 0;
      var touchScrollStart = 0;

      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].pageX;
        touchScrollStart = carousel.scrollLeft;
        carousel.style.scrollSnapType = 'none';
      }, { passive: true });

      carousel.addEventListener('touchmove', function(e) {
        var diff = e.touches[0].pageX - touchStartX;
        carousel.scrollLeft = touchScrollStart - diff;
      }, { passive: true });

      carousel.addEventListener('touchend', function() {
        carousel.style.scrollSnapType = 'x mandatory';
        var scrollAmt = getScrollAmount();
        var targetIndex = Math.round(carousel.scrollLeft / scrollAmt);
        carousel.scrollTo({ left: targetIndex * scrollAmt, behavior: 'smooth' });
      }, { passive: true });

      /* Keyboard navigation */
      carousel.setAttribute('tabindex', '0');
      carousel.setAttribute('role', 'region');
      carousel.setAttribute('aria-label', 'Reviews carousel');
      carousel.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollNext();
        }
      });
    }

    /* ---- SLIDE CARDS ---- */
    var slideGrid = root.querySelector('[data-slide-grid]');
    if (slideGrid) {
      var slideCards = slideGrid.querySelectorAll('[data-slide-card]');
      slideCards.forEach(function(card) {
        card.addEventListener('click', function() {
          card.classList.toggle('is-expanded');
        });
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            card.classList.toggle('is-expanded');
          }
        });
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');
        card.setAttribute('aria-label', 'Click to expand and read review');
      });
    }

    /* ---- SPOTLIGHT MODE ---- */
    var spotlight = root.querySelector('[data-spotlight]');
    if (spotlight) {
      var spotCards = spotlight.querySelectorAll('.nv-reviews__card');
      var spotIndex = Math.floor(spotCards.length / 2);
      var spotPrev = root.querySelector('[data-spotlight-prev]');
      var spotNext = root.querySelector('[data-spotlight-next]');

      function updateSpotlight() {
        spotCards.forEach(function(card, i) {
          card.classList.toggle('is-center', i === spotIndex);
        });
      }

      spotCards.forEach(function(card, i) {
        card.addEventListener('click', function() {
          if (i !== spotIndex) {
            spotIndex = i;
            updateSpotlight();
          }
        });
      });

      if (spotPrev) {
        spotPrev.addEventListener('click', function() {
          spotIndex = (spotIndex - 1 + spotCards.length) % spotCards.length;
          updateSpotlight();
        });
      }
      if (spotNext) {
        spotNext.addEventListener('click', function() {
          spotIndex = (spotIndex + 1) % spotCards.length;
          updateSpotlight();
        });
      }

      updateSpotlight();
    }

    /* ---- SINGLE FOCUS MODE ---- */
    var singleWrap = root.querySelector('[data-single]');
    if (singleWrap) {
      var singleCards = singleWrap.querySelectorAll('.nv-reviews__card');
      var singleIndex = 0;
      var singlePrev = root.querySelector('[data-single-prev]');
      var singleNext = root.querySelector('[data-single-next]');
      var singleCounter = root.querySelector('[data-single-current]');
      var isAnimating = false;
      var animDuration = 400;

      function showSingleCard(newIndex) {
        if (isAnimating || newIndex === singleIndex || singleCards.length < 2) return;
        isAnimating = true;

        var oldCard = singleCards[singleIndex];
        var newCard = singleCards[newIndex];

        oldCard.classList.remove('is-active');
        newCard.classList.add('is-active');

        setTimeout(function() {
          isAnimating = false;
        }, animDuration);

        singleIndex = newIndex;
        if (singleCounter) singleCounter.textContent = singleIndex + 1;
      }

      if (singleCards.length > 0) {
        singleCards[0].classList.add('is-active');
      }

      if (singlePrev) {
        singlePrev.addEventListener('click', function() {
          var newIdx = (singleIndex - 1 + singleCards.length) % singleCards.length;
          showSingleCard(newIdx);
        });
      }
      if (singleNext) {
        singleNext.addEventListener('click', function() {
          var newIdx = (singleIndex + 1) % singleCards.length;
          showSingleCard(newIdx);
        });
      }
    }
/* ---- TICKER / MARQUEE (JS-DRIVEN rAF) ---- */
    var tickerCleanup = null;
    var marqueeCleanup = null;

    function initScrollTrack(track, speedVar) {
      if (!track || track.children.length === 0) return null;

      /* 1. Clean previous state */
      var oldClones = track.querySelectorAll('[data-clone]');
      for (var c = 0; c < oldClones.length; c++) {
        oldClones[c].parentNode.removeChild(oldClones[c]);
      }
      track.style.transform = '';

      /* 2. Collect originals */
      var originals = [];
      for (var i = 0; i < track.children.length; i++) {
        originals.push(track.children[i]);
      }
      if (originals.length === 0) return null;

      /* 3. Measure one original set width */
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var setWidth = 0;
      for (var m = 0; m < originals.length; m++) {
        setWidth += originals[m].offsetWidth + gap;
      }
      if (setWidth <= 0) return null;

      /* 4. Viewport width for clone calculation + reduced motion guard.
            If the user prefers reduced motion: do NOT clone and do NOT
            animate. Center the originals only when they do not fill the
            viewport, otherwise leave them flush.
            Otherwise: clear any stale centering and fall through so
            step 5 clones enough sets to fill the viewport and the
            marquee animation can run. The animation loop wraps at
            exactly setWidth, so a short setWidth is fine. */
      var viewW = window.innerWidth || document.documentElement.clientWidth;
      track.style.justifyContent = '';
      if (reduced) {
        if (setWidth < viewW) {
          track.style.justifyContent = 'center';
        }
        return null;
      }

      /* 5. Clone enough full sets to fill 3x viewport.
            The animation resets at exactly setWidth pixels,
            so the loop is seamless regardless of clone count. */
      var clonesNeeded = Math.max(2, Math.ceil((viewW * 3) / setWidth));
      for (var s = 0; s < clonesNeeded; s++) {
        for (var j = 0; j < originals.length; j++) {
          var cl = originals[j].cloneNode(true);
          cl.setAttribute('data-clone', 'true');
          cl.removeAttribute('data-shopify-editor-block');
          cl.classList.remove('is-active', 'is-center');
          track.appendChild(cl);
        }
      }

      /* 6. If reduced motion, show static cards, no scroll */
      if (reduced) return null;

      /* 6. Compute scroll speed: px per frame at 60fps.
            speedVar is CSS duration in seconds (higher = slower). */
      var speedSec = parseFloat(getComputedStyle(root).getPropertyValue(speedVar)) || 30;
      var pxPerFrame = setWidth / (speedSec * 60);
      var isReverse = track.classList.contains('nv-reviews__marquee--reverse');

      var offset = 0;
      var paused = false;
      var rafId = null;

      function onEnter() { paused = true; }
      function onLeave() { paused = false; }
      track.addEventListener('mouseenter', onEnter);
      track.addEventListener('mouseleave', onLeave);

      function tick() {
        if (!paused) {
          offset += pxPerFrame;
          if (offset >= setWidth) offset -= setWidth;
          track.style.transform = 'translateX(' + (isReverse ? offset : -offset).toFixed(1) + 'px)';
        }
        rafId = requestAnimationFrame(tick);
      }

      rafId = requestAnimationFrame(tick);

      /* Return cleanup function */
      return function() {
        if (rafId) cancelAnimationFrame(rafId);
        track.removeEventListener('mouseenter', onEnter);
        track.removeEventListener('mouseleave', onLeave);
        track.style.transform = '';
      };
    }

    var tickerTrack = root.querySelector('[data-ticker]');
    var marqueeTrack = root.querySelector('[data-marquee]');
    if (tickerTrack) tickerCleanup = initScrollTrack(tickerTrack, '--nv-ticker-speed');
    if (marqueeTrack) marqueeCleanup = initScrollTrack(marqueeTrack, '--nv-marquee-speed');

    /* Recalculate on resize */
    var scrollResizeTimer = null;
    window.addEventListener('resize', function() {
      clearTimeout(scrollResizeTimer);
      scrollResizeTimer = setTimeout(function() {
        if (tickerCleanup) tickerCleanup();
        if (marqueeCleanup) marqueeCleanup();
        tickerTrack = root.querySelector('[data-ticker]');
        marqueeTrack = root.querySelector('[data-marquee]');
        if (tickerTrack) tickerCleanup = initScrollTrack(tickerTrack, '--nv-ticker-speed');
        if (marqueeTrack) marqueeCleanup = initScrollTrack(marqueeTrack, '--nv-marquee-speed');
      }, 300);
    });

    /* Theme editor reinit */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail && e.detail.sectionId === sid) {
          if (tickerCleanup) tickerCleanup();
          if (marqueeCleanup) marqueeCleanup();
          var newRoot = document.querySelector('#nv-google-reviews-glass[data-section-id="' + sid + '"]');
          if (newRoot) {
            var tt = newRoot.querySelector('[data-ticker]');
            var mt = newRoot.querySelector('[data-marquee]');
            if (tt) tickerCleanup = initScrollTrack(tt, '--nv-ticker-speed');
            if (mt) marqueeCleanup = initScrollTrack(mt, '--nv-marquee-speed');
          }
        }
      });
    }
    /* ---- CONNECTED MODE ---- */
    var source = root.getAttribute('data-reviews-source');
    if (source === 'connected') {
      var proxyPath = root.getAttribute('data-proxy-path') || '';
      var placeId = root.getAttribute('data-place-id') || '';
      var lang = root.getAttribute('data-lang') || '';
      var minStar = parseInt(root.getAttribute('data-min-star') || '4', 10);
      var maxShow = parseInt(root.getAttribute('data-max-show') || '12', 10);
      var excludeIds = (root.getAttribute('data-exclude-ids') || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      var excludeAuthors = (root.getAttribute('data-exclude-authors') || '').split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var excludeKeywords = (root.getAttribute('data-exclude-keywords') || '').split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var allowlistIds = (root.getAttribute('data-allowlist-ids') || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      var allowlistOnly = root.getAttribute('data-allowlist-only') === 'true';
      var fallbackManual = root.getAttribute('data-fallback-manual') !== 'false';
      var gridEl = root.querySelector('[data-reviews-container]');
      var loadingEl = root.querySelector('.nv-reviews__loading');
      var manualEl = root.querySelector('[data-reviews-manual]');
      var isEditor = window.Shopify && window.Shopify.designMode;

      if (proxyPath && placeId && gridEl) {
        var url = proxyPath + '?place_id=' + encodeURIComponent(placeId);
        if (lang) url += '&lang=' + encodeURIComponent(lang);

        fetch(url)
          .then(function(res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function(data) {
            if (!data || !data.reviews || !data.reviews.length) throw new Error('empty');

            var filtered = data.reviews.filter(function(r) {
              if (allowlistOnly && allowlistIds.length) {
                return allowlistIds.indexOf(r.review_id) !== -1;
              }
              if (r.rating < minStar) return false;
              if (excludeIds.indexOf(r.review_id) !== -1) return false;
              if (excludeAuthors.indexOf(r.author_name.toLowerCase()) !== -1) return false;
              if (excludeKeywords.length) {
                var txt = (r.text || '').toLowerCase();
                for (var k = 0; k < excludeKeywords.length; k++) {
                  if (txt.indexOf(excludeKeywords[k]) !== -1) return false;
                }
              }
              return true;
            }).slice(0, maxShow);

            if (!filtered.length) throw new Error('empty_after_filter');

            if (loadingEl) loadingEl.style.display = 'none';
            if (manualEl) manualEl.style.display = 'none';

            var html = '';
            filtered.forEach(function(r) {
              var stars = '';
              for (var s = 1; s <= 5; s++) {
                if (s <= r.rating) {
                  stars += '<svg viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
                } else {
                  stars += '<svg class="is-empty" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
                }
              }

              var verifyLink = '';
              if (r.review_url) {
                verifyLink = '<a href="' + r.review_url + '" target="_blank" rel="noopener" class="nv-reviews__card-verify" aria-label="View this review on Google in a new tab"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>View on Google</a>';
              }

              html += '<div class="nv-reviews__card">' +
                '<div class="nv-glass-tint"></div><div class="nv-glass-noise"></div><div class="nv-glass-edge"></div>' +
                '<div class="nv-reviews__card-content">' +
                '<div class="nv-reviews__card-top"><div><p class="nv-reviews__card-author">' + (r.author_name || 'Anonymous') + '</p>' +
                (r.relative_time_description ? '<p class="nv-reviews__card-meta">' + r.relative_time_description + '</p>' : '') +
                '</div></div>' +
                '<div class="nv-reviews__card-stars">' + stars + '</div>' +
                '<div class="nv-reviews__card-text"><p>' + (r.text || '') + '</p></div>' +
                verifyLink +
                '</div></div>';
            });

            gridEl.innerHTML = html;

            /* Update authority bar with live data */
            var authRating = root.querySelector('[data-authority-rating]');
            var authCount = root.querySelector('[data-authority-count]');
            if (authRating && data.rating) authRating.textContent = data.rating;
            if (authCount && data.user_ratings_total) authCount.textContent = data.user_ratings_total + ' reviews';
          })
          .catch(function() {
            if (loadingEl) loadingEl.style.display = 'none';
            if (fallbackManual && manualEl) {
              manualEl.style.display = '';
            }
            if (isEditor) {
              var warn = document.createElement('div');
              warn.className = 'nv-reviews__editor-warning';
              warn.textContent = 'Connected mode: Could not fetch reviews. Falling back to manual blocks.';
              gridEl.parentNode.insertBefore(warn, gridEl.nextSibling);
            }
          });
      }
    }
  });
})();
